// Rebuilds a page's filter form from the searchBody kept in the store, so the
// filters survive leaving the page. searchBody holds "" where the form had
// null, so empty values fall back to the form default.
export const restoreFilters = (defaults, saved = {}) =>
  Object.fromEntries(
    Object.entries(defaults).map(([key, value]) => [
      key,
      saved[key] === undefined || saved[key] === "" ? value : saved[key],
    ])
  );
